import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=39367743"
import script from "./Comparator.vue?vue&type=script&lang=js"
export * from "./Comparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports